import React, { useState } from 'react'
import { motion } from 'framer-motion'
import {Button, Grid} from "@mui/material"
import useStyles from './MainTitle'
import styled from '@emotion/styled'

const ButtonStyled = styled(Button)(({theme})=> ({
    margin: "5px 10px",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: "white !important",
    },
    "&.active": {
      backgroundColor: theme.palette.primary.main,
      color: "white !important",
    }
}))
function MenuTabs({filterItems, categories, setCategories}) {
    const [genreActive, setGenreActive] = useState("all")
    const classes = useStyles()
  return (
    <motion.article className={classes.tabsStyled}>
        {categories.map((category, index)=> {
            return (
              <motion.div initial={{opacity: 0, y: 140}} animate={{opacity: 1, y: 0, transition: {duration: .7, delay: 1}}}>
                <ButtonStyled key={index} variant='outlined' onClick={(e) => {
                    filterItems(category)
                    setGenreActive(e.target.textContent)
                  }} className={genreActive === category ? "active" : ""}>{category}
                </ButtonStyled>
              </motion.div>
            )
        })}
    </motion.article>
  )
}

export default MenuTabs
